import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { usePurgeLocationMutation } from "modules/DMSv3/Settings/components/AddEditLocationModal/hooks";

type PurgeLocationModalProps = {
  dealer_location_id: number | null;
  onCancel: () => void;
  onClose: () => void;
};

export const PurgeLocationModal = ({ dealer_location_id, onCancel, onClose }: PurgeLocationModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: purgeLocation, isPending: isPurgeLocationPending } = usePurgeLocationMutation();

  const handlePurgeLocation = async () => {
    if (!dealer_location_id) return;
    await purgeLocation(dealer_location_id);
    onClose();
  };

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={dealer_location_id !== null}
      handleCancel={onCancel}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={t("v8_purge_confirm_message", "Are you sure that you want to purge this location? You can't undo this action.")}
      handleConfirm={handlePurgeLocation}
      isLoading={isPurgeLocationPending}
    />
  );
};
